module.exports = __webpack_public_path__ + "static/media/notFound3.5917750c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notFound3.jpg
// module id = 1251
// module chunks = 0